import React, {lazy} from "react";
import { withRouter } from 'react-router';
import Slider from 'Component/Slider';
import media, { WYSIWYG_MEDIA } from "Util/Media/Media";
import CarouselScroll from 'Component/CarouselScroll';
import { TransformWrapper } from 'react-zoom-pan-pinch';
import ProductGalleryBaseImage from 'Component/ProductGalleryBaseImage';
import ProductGalleryThumbnailImage from 'Component/ProductGalleryThumbnailImage';
import Image from 'Component/Image';

import { ProductGallery as SourceProductGallery } from 'SourceComponent/ProductGallery/ProductGallery.component';

export const UniversalIcon = lazy(() => import(
    /* webpackMode: "lazy", webpackChunkName: "icons" */
    'Component/UniversalIcon'
    ));

export class ProductGallery extends SourceProductGallery {

    state = {
        scrollEnabled: true,
        slidesCount: 5,
        prevZoom: false
    };

    componentDidMount() {
        this.updateSharedDestinationElement();
        setTimeout(function() {
            window.dispatchEvent(new Event('resize'));
        }, 1000);
        window.addEventListener('resize', this.calculateGallerySize);
    }

    renderAdditionalPicture = (media, index = 0) => (
        <ProductGalleryThumbnailImage
            key={ index }
            media={ media }
            productName={ this.props.productName }
        />
    );

    renderAdditionalPictures() {
        const {
            gallery,
            isImageZoomPopupActive,
            activeImage,
            onActiveImageChange,
            isProductPopup
        } = this.props;

        const { slidesCount } = this.state;

        if (gallery.length === 1) {
            return <div block="ProductGallery" elem="Additional" />;
        }

        return (
            <div block="ProductGallery" elem="Additional" mods={ { isImageZoomPopupActive } }>
                <CarouselScroll
                    activeItemId={ activeImage }
                    onChange={ onActiveImageChange }
                    showedItemCount={ slidesCount }
                    isImageZoomPopupActive={ isImageZoomPopupActive }
                    isProductGallery={isProductPopup ? false : true}
                    isProductPopup={isProductPopup}
                >
                    { gallery.map(this.renderAdditionalPicture) }
                </CarouselScroll>
            </div>
        );
    }

    renderImage(mediaData, index) {
        const {
            isZoomEnabled,
            handleZoomChange,
            disableZoom,
            isMobile,
            isImageZoomPopupActive,
            productName
        } = this.props;
        const { scrollEnabled } = this.state;

        if (!isMobile) {
            const {
                base: { url: baseSrc } = {},
                large: { url: largeSrc } = {}
            } = mediaData;

            const style = isImageZoomPopupActive ? { height: 'auto' } : {};
            const src = isImageZoomPopupActive ? largeSrc : baseSrc;
            
            return (
                <Image
                    key={ index }
                    src={ src }
                    alt={ mediaData?.label }
                    ratio="custom"
                    mix={ {
                        block: 'ProductGallery',
                        elem: 'SliderImage',
                        mods: { isPlaceholder: !src }
                    } }
                    isPlaceholder={ !src }
                    style={ style }
                />
            );
        }

        return (
            <TransformWrapper
                key={ index }
                onZoomChange={ handleZoomChange }
                onWheelStart={ this.onWheelStart }
                onWheel={ this.onWheel }
                wheel={ { limitsOnWheel: true, disabled: !scrollEnabled } }
                //   doubleClick={ { mode: 'reset' } }
                pan={ {
                    disabled: !isZoomEnabled,
                    limitToWrapperBounds: true,
                    velocity: false
                } }
                options={ {
                    limitToBounds: true,
                    minScale: 1
                } }
            >
                { ({
                       scale,
                       previousScale,
                       resetTransform,
                       setTransform
                   }) => {
                    if (scale === 1 && previousScale !== 1) {
                        resetTransform();
                    }

                    return (
                        <ProductGalleryBaseImage
                            setTransform={ setTransform }
                            index={ index }
                            mediaData={ mediaData }
                            scale={ scale }
                            previousScale={ previousScale }
                            disableZoom={ disableZoom }
                            isZoomEnabled={ isZoomEnabled }
                        />
                    );
                } }
            </TransformWrapper>
        );
    }

    renderSlider() {
        const {
            gallery,
            activeImage,
            isZoomEnabled,
            onActiveImageChange,
            isImageZoomPopupActive,
            sliderRef,
            isMobile
        } = this.props;

        const mods = {
            isImageZoomPopupActive,
            isZoomInCursor: !isImageZoomPopupActive
        };

        const isMoreThanOnePhoto = gallery.length > 1;

        return (
            <div
              ref={ this.imageRef }
              block="ProductGallery"
              elem="SliderWrapper"
            >
                {/* <meta itemProp="image" content={ this.getImageUrl() } /> */}
                <Slider
                  sliderRef={ sliderRef }
                  mix={ { block: 'ProductGallery', elem: 'Slider', mods } }
                  showCrumbs={ isMoreThanOnePhoto }
                  showArrows={ !isMobile && isMoreThanOnePhoto }
                  activeImage={ activeImage }
                  onActiveImageChange={ onActiveImageChange }
                  isInteractionDisabled={ isZoomEnabled }
                  onClick={ this.handleSliderClick }
                  sliderHeight={ isImageZoomPopupActive ? '100%' : 0 }
                  isHeightTransitionDisabledOnMount
                >
                    { gallery.map(this.renderSlide) }
                </Slider>
                { !isMobile ?
                    <UniversalIcon
                        src={media('zoomin.svg', WYSIWYG_MEDIA)}
                        alt="expandIcon"
                        className="ProductGallery-ExpandIcon"
                        onClick={ this.handleSliderClick }
                    />
                    : '' }
            </div>
        );
    }

}

export default withRouter(ProductGallery);
